import { UserMessage } from '@/interfaces/userMessage.interface'
import { getUserMessage } from '@/services/userMessage.service'
import md5 from 'md5'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUserMessage = defineStore('userMessage', () => {
  const isUserMessageActive = ref<boolean>(true)
  const messageText = ref<string>('')
  const messages = ref(<UserMessage[]>[])

  async function fetchUserMessage() {
    try {
      messages.value = (await getUserMessage()).filter((msg) => {
        // TODO: use id instead of md5 hash when backend supports it
        const hash = md5(JSON.stringify(msg))
        const closedMessages = JSON.parse(localStorage.getItem('closedMessages') ?? '[]')
        return !closedMessages.includes(hash)
      })
    } catch (error) {
      console.error('Failed to fetch user message', error)
      messageText.value = 'Failed to load messages'
    }
  }

  function closeMessage(message: UserMessage) {
    // TODO: use id instead of md5 hash when backend supports it
    const hash = md5(JSON.stringify(message))
    localStorage.setItem(
      'closedMessages',
      JSON.stringify([...JSON.parse(localStorage.getItem('closedMessages') ?? '[]'), hash])
    )
    messages.value = messages.value.filter((msg) => msg != message)
    if (messages.value.length === 0) {
      isUserMessageActive.value = false
    }
  }

  return {
    isUserMessageActive,
    messages,
    fetchUserMessage,
    closeMessage
  }
})
